var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Field',_vm._g(_vm._b({},'Field',_vm.fieldProps.attrs,false),_vm.fieldProps.on),[(_vm.isUserName)?_c('label',{class:_vm.$style['editIcon'],attrs:{"slot":"input-right","for":"userName"},slot:"input-right"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }